import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { GET_USER } from "@constants";
import APICaller from "@services/ApiRequest";
import { useAuthState } from "../../store/hooks";

const AuthVerify = ({ logOut }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isChecking = useRef(false);
  const didNavigate = useRef(false);
  const { isLoggedIn } = useAuthState((state) => state);

  useEffect(() => {
    const checkSession = async () => {
      if (!localStorage.getItem("user") && !isLoggedIn) return;
      if (isChecking.current) return;
      isChecking.current = true;

      try {
        await APICaller(GET_USER);
      } catch (err) {
        if (axios.isCancel(err)) return;

        const status = err.response?.status;
        if ((status === 401 || status === 403) && !didNavigate.current) {
          logOut();
          didNavigate.current = true;
          navigate("/login");
        } else {
          console.warn("Session check failed but not unauthorized:", err);
        }
      } finally {
        isChecking.current = false;
      }
    };

    const timer = setTimeout(checkSession, 100);

    return () => clearTimeout(timer);
  }, [location, logOut, navigate]);

  return null;
};

export default AuthVerify;
